var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureSqlDb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.85258C7.28024 6.85258 3.45337 5.51964 3.45337 3.75977V20.2391C3.45337 21.9326 7.21368 23.3059 11.8798 23.3329H12C16.7197 23.3329 20.5466 21.9992 20.5466 20.2391V3.75977C20.5466 5.47952 16.7197 6.85258 12 6.85258Z",
    fill: "url(#paint0_linear_23109_175486)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5466 3.75977C20.5466 5.47952 16.7197 6.85277 12 6.85277C7.28024 6.85277 3.45337 5.51964 3.45337 3.75977C3.45337 1.9997 7.28024 0.666016 12 0.666016C16.7197 0.666016 20.5466 1.9997 20.5466 3.75977Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5602 3.50681C18.5602 4.60031 15.6131 5.48006 11.9999 5.48006C8.38682 5.48006 5.4397 4.60031 5.4397 3.50681C5.4397 2.41331 8.38682 1.54688 11.9999 1.54688C15.6131 1.54688 18.5602 2.42644 18.5602 3.50681Z",
    fill: "#50E6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.99971C10.2403 3.95506 8.48588 4.21221 6.81299 4.76003C8.48744 5.29776 10.2424 5.54136 12 5.48003C13.7611 5.53144 15.5174 5.26956 17.187 4.70659C15.5093 4.1844 13.7563 3.94551 12 3.99971Z",
    fill: "#198AB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2001 15.2004V10.6675H15.9998V16.1739H19.2803V15.2004H17.2001ZM7.68021 12.9738C7.43239 12.8741 7.20254 12.7346 6.99977 12.5607C6.94601 12.5038 6.90418 12.4367 6.87675 12.3634C6.84931 12.2901 6.83682 12.212 6.84002 12.1338C6.83595 12.0555 6.85225 11.9775 6.88731 11.9074C6.92237 11.8374 6.97501 11.7775 7.04008 11.7339C7.20417 11.6204 7.40105 11.564 7.60033 11.5735C8.07512 11.5524 8.54364 11.6883 8.93346 11.9602V10.814C8.50767 10.655 8.05446 10.5826 7.60033 10.6008C7.07715 10.5727 6.56126 10.7334 6.14646 11.0534C5.9658 11.1928 5.82086 11.3732 5.72358 11.5796C5.6263 11.786 5.57947 12.0126 5.58696 12.2407C5.58696 12.9204 6.01314 13.4536 6.92008 13.8535C7.21446 13.9788 7.49196 14.1399 7.74696 14.3339C7.80928 14.3862 7.85945 14.4514 7.89397 14.525C7.92849 14.5987 7.94653 14.679 7.94683 14.7603C7.94683 14.9251 7.86696 15.0789 7.73364 15.1741C7.55189 15.2801 7.34323 15.331 7.13308 15.3205C6.59682 15.3161 6.08043 15.117 5.67996 14.7603V16.0002C6.12027 16.2275 6.61163 16.3377 7.10683 16.3203C7.66558 16.3533 8.21927 16.1988 8.67996 15.88C8.84258 15.7261 8.96706 15.5363 9.04348 15.3257C9.11991 15.1152 9.14618 14.8898 9.12021 14.6673C9.12672 14.326 9.00814 13.9941 8.78683 13.7341C8.47529 13.4059 8.09827 13.1469 7.68021 12.9738ZM14.6668 15.0935C14.9695 14.5866 15.1221 14.0042 15.1069 13.414C15.0767 12.9142 14.9257 12.4291 14.6668 12.0005C14.4587 11.5842 14.1346 11.237 13.7336 11.0007C13.3272 10.7702 12.8673 10.6504 12.4 10.6535C11.8964 10.6426 11.3991 10.7671 10.96 11.0139C10.5483 11.2435 10.2106 11.5857 9.98664 12.0005C9.75062 12.4718 9.63176 12.9931 9.64014 13.5202C9.64279 13.9835 9.75232 14.44 9.96021 14.854C10.1638 15.2657 10.4836 15.6087 10.8801 15.8405C11.2829 16.0858 11.7419 16.2235 12.2132 16.2404L13.3601 17.5735H14.9736L13.333 16.1073C13.8854 15.9415 14.3592 15.5814 14.6668 15.0935ZM13.333 14.7603C13.2117 14.9111 13.0571 15.0317 12.8814 15.1126C12.7056 15.1936 12.5135 15.2327 12.3201 15.2268C12.1251 15.2332 11.9315 15.193 11.7552 15.1096C11.5789 15.0261 11.4251 14.9018 11.3065 14.747C11.0251 14.3618 10.8882 13.89 10.9196 13.414C10.889 12.938 11.0259 12.4662 11.3065 12.0804C11.4319 11.9256 11.5905 11.801 11.7705 11.7157C11.9505 11.6303 12.1473 11.5864 12.3465 11.5872C12.5413 11.5786 12.7351 11.6193 12.91 11.7055C13.0849 11.7917 13.2352 11.9206 13.347 12.0804C13.6095 12.4737 13.7358 12.9421 13.7066 13.414C13.7535 13.8936 13.6203 14.3735 13.333 14.7603Z",
    fill: "url(#paint1_radial_23109_175486)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23109_175486",
    x1: 3.45333,
    y1: 13.5461,
    x2: 20.5467,
    y2: 13.5461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0074CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#006ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BA1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_23109_175486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9774.45 3146.71) scale(7070.68 1834.07)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureSqlDb);
export default __webpack_public_path__ + "static/media/AzureSqlDB.4dac6bbbb2fd2e19aacddf468ac6caeb.svg";
export { ForwardRef as ReactComponent };